import * as Long from "long";
import * as React from "react";
import { useEffect, useState } from "react";
import { StoreConstants } from "../../constants/StoreConstants";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { TextLoca } from "../generic/text/TextLoca";
import { TradeComponent } from "../trade-component/TradeComponent";
export var StoreItemResourcePurchase = function (_a) {
    var _b = _a.item, id = _b.balancing.id, purchasedResourceInfo = _b.purchasedResourceInfo, costResourceInfo = _b.costResourceInfo, onBuyPackage = _a.onBuyPackage, isLocked = _a.isLocked;
    var _c = useState(1), sliderValue = _c[0], setSliderValue = _c[1];
    useEffect(function () {
        setSliderValue(1);
    }, [id]);
    var onSliderChange = function (value) {
        setSliderValue(value);
    };
    return (React.createElement("div", { className: "store-menu-detail__purchase" },
        React.createElement(TradeComponent, { purchasedResourceAmount: purchasedResourceInfo.amount.multiply(sliderValue), purchasedResourceInfo: purchasedResourceInfo, onSliderChange: onSliderChange, sliderValue: sliderValue, wastedResourceAmount: costResourceInfo.amount.multiply(sliderValue), wastedResourceInfo: costResourceInfo, wastedResourceMaxAmount: Long.fromNumber(StoreConstants.MaxBuyAmount), wastedResourceMinAmount: Long.ONE, backgroundStyle: IdStyles.InventoryBuyContainerCost }),
        React.createElement(ButtonSecondary, { onClick: function () { return onBuyPackage(sliderValue); }, disabled: isLocked },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.buy }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/StoreItemResourcePurchase.tsx
// module id = 2762
// module chunks = 3